module.exports = __webpack_public_path__ + "static/img/login_img.846d7c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_img.png
// module id = qA5R
// module chunks = 1